import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    selectors: {
      '.ms-Dialog-title': {
        paddingTop: pxToRem(32),
        paddingBottom: pxToRem(12),
      },
      '.ms-Dialog-inner': {
        paddingBottom: pxToRem(32),
      },
      '.ms-Dialog-actions': {
        marginTop: pxToRem(24),
      },
    },
  },
  modalText: {
    fontWeight: 400,
    fontSize: pxToRem(16),
  },
  modalBoldText: {
    fontWeight: 600,
  },
  saving: {
    paddingTop: 0,
    marginLeft: pxToRem(10),
  },
  dialogContent: {
    paddingTop: pxToRem(15),
  },
});
